module.exports = __webpack_public_path__ + "img/PUBLIC_GARDEN.3110b18c.png";